import moment from 'moment/moment';
import { formatNumber } from '../helpers';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/helpers/shadcn';

// Every feature for one company, highest overall score first, so what it leans on sits at the
// top and what it ignores sinks to the bottom.
const CompanyBreakdown = ({ company, catalogue, cells, score, onClose }) => {
  const features = (cells ? catalogue : [])
    .map((feature) => ({ feature, cell: cells[feature.key] }))
    .sort((a, b) => b.cell.overall - a.cell.overall || b.cell.requests - a.cell.requests || (b.cell.total ?? 0) - (a.cell.total ?? 0));
  const used = features.filter(({ cell }) => cell.requests > 0).length;

  return (
    <Sheet open={!!company} onOpenChange={(open) => !open && onClose()}>
      <SheetContent className="overflow-y-auto sm:max-w-4xl">
        {company && (
          <>
            <SheetHeader>
              <SheetTitle>{company.company_name}</SheetTitle>
              <SheetDescription>
                Overall score {score} · used {used} of {catalogue.length} features in this window
              </SheetDescription>
            </SheetHeader>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Feature</TableHead>
                  <TableHead className="text-right">Overall</TableHead>
                  <TableHead className="text-right">Users</TableHead>
                  <TableHead className="text-right">Days</TableHead>
                  <TableHead className="text-right">Writes</TableHead>
                  <TableHead className="text-right">Requests</TableHead>
                  <TableHead className="text-right">Created</TableHead>
                  <TableHead className="text-right">Total</TableHead>
                  <TableHead className="whitespace-nowrap">Last created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {features.map(({ feature, cell }) => (
                  <TableRow key={feature.key} className={cn(!cell.requests && !cell.total && 'text-muted-foreground')}>
                    <TableCell className="py-2">
                      <div className="font-medium">{feature.label}</div>
                      <div className="text-xs text-muted-foreground">{feature.area_label}</div>
                    </TableCell>
                    <TableCell className="py-2 text-right font-medium tabular-nums">{cell.overall}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.active_users)}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.active_days)}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.writes)}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.requests)}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.created_in_window)}</TableCell>
                    <TableCell className="py-2 text-right tabular-nums">{formatNumber(cell.total)}</TableCell>
                    <TableCell className="whitespace-nowrap py-2">{cell.last_created ? moment(cell.last_created).fromNow() : '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CompanyBreakdown;
